<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destinations', 'matching-automatic', 'export-destination-data-studio', 'export-destination-google-drive', 'export-destination-ftp']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
